import React from 'react'
import {
  Redirect,
  Link
} from 'react-router-dom'
import { patientsDatabase, polyglot } from '../../../index'
import PropTypes from 'prop-types'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import { isDateInputAvailable } from '../../../resources/utilities'
import './style.css'
import { Panel } from '../../common/Panel/Panel'

const dateFormat = {
  standartData: 'YYYY-MM-DD'
}

export default class PatientPicker extends React.Component {
  constructor (props) {
    super(props)
    this.getPatient = this.getPatient.bind(this)
    this.state = {
      patientId: '',
      alert: 'hidden',
      redirectToReferrer: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount () {
    this.props.patientChangeHandle(undefined, undefined)
  }

  getPatient (patientNumber) {
    let patient, patientKey
    patientsDatabase.on('value', snapshot => {
      snapshot.forEach((childSnap) => {
        if (childSnap.child('patientNumber').val() === patientNumber) {
          patient = childSnap.val()
          patientKey = childSnap.key
        }
      })
      if (patient) {
        this.setState({
          redirectToReferrer: true
        }, this.props.patientChangeHandle(patient['patientNumber'], patientKey))
      } else {
        this.setState({
          alert: 'alert alert-danger'
        })
      }
    })
  }

  handleSubmit (event) {
    event.preventDefault()
    this.getPatient(this.state.patientId)
  }

  handleChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  render () {
    const {redirectToReferrer} = this.state
    return (
      <div className='container-fluid'>
        <div className='col-xs-12 col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3 patient-number-container'>
          {redirectToReferrer && (
            <Redirect to={{pathname: `/patients/${this.state.patientId}`}} />
          )}
          <PatientNumberForm alert={this.state.alert} handleChange={this.handleChange} patientId={this.state.patientId} handleSubmit={this.handleSubmit} />
        </div>
        <div className='col-xs-12 col-md-12 col-lg-10 col-lg-offset-1 patients-table no-side-padding'>
          <Panel heading={polyglot.t('staticFields.patientPicker.patients')}>
            <PatientsTable />
          </Panel>
        </div>
        <br />
        {/* <div className='col-xs-12'> */}
        {/* <Link to={`${this.props.match.url}/addPatient`}> */}
        {/* <Button text={polyglot.t('staticFields.patientPicker.addNewPatient')} buttonType='btn-default btn-lg center-block' type='button' /> */}
        {/* </Link> */}
        {/* </div> */}
      </div>
    )
  }
}

PatientPicker.propTypes = {
  patientChangeHandle: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired
}

class PatientsTable extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      noPatients: false,
      search: '',
      currentDoctorPatients: null
    }
    this.searchPatientByBirthday = this.searchPatientByBirthday.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.getAllPatients = this.getAllPatients.bind(this)
  }

  componentWillMount () {
    this.getAllPatients()
  }

  searchPatientByBirthday () {
    if (this.state.search !== '') {
      let value
      if (typeof (this.state.search) === 'string') {
        value = this.state.search
      } else {
        value = (this.state.search).format('yyyy-MM-dd')
      }
      let patients = {}
      patientsDatabase.on('value', snapshot => {
        snapshot.forEach((childSnap) => {
          if (childSnap.child('birthDate').val() === value) {
            patients[childSnap.key] = childSnap.val()
          }
        })
        if (Object.keys(patients).length === 0) {
          this.setState({
            currentDoctorPatients: null
          })
        } else {
          this.setState({
            currentDoctorPatients: patients
          })
        }
      })
    }
  }

  getAllPatients () {
    let currentDoctorPatients = null
    patientsDatabase.on('value', snapshot => {
      currentDoctorPatients = snapshot.val()
      if (currentDoctorPatients !== null) {
        this.setState({
          currentDoctorPatients: currentDoctorPatients
        })
      } else {
        this.setState({
          noPatients: true
        })
      }
    })
  }

  handleChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleDateChange (date) {
    this.setState({
      search: date
    })
  }

  renderNoPatients () {
    return <tr><td colSpan='3' >{polyglot.t('staticFields.patientPicker.patientsTable.noPatients')}</td></tr>
  }

  renderLoading () {
    return <tr><td colSpan='3' >{polyglot.t('staticFields.patientPicker.patientsTable.loading')}</td></tr>
  }

  render () {
    return <div>
      <div className='panel'>
        <div className='form-horizontal'>
          <div>
            <label className='col-sm-3 control-label'>{polyglot.t('staticFields.patientPicker.patientsTable.birthDate')}</label>
            <div className='col-sm-9 date-picker-input no-side-padding'>
              {isDateInputAvailable()
                ? <input type='date' name='search' onChange={(e) => this.handleChange(e)} required
                  className='form-control margin-horizontal-input padding-input col-xs-12' value={this.state.search ? moment(new Date(this.state.search)).format(dateFormat.standartData) : ''}
                  placeholder='Nascimento' />
                : <DatePicker className='form-control' name='search' selected={this.state.search} onChange={this.handleDateChange} />
              }
            </div>
          </div>
          <button className='btn btn-default btn-block vertical-margin' onClick={this.searchPatientByBirthday}>{polyglot.t('staticFields.patientPicker.patientsTable.search')}</button>
          <button className='btn btn-default btn-block vertical-margin' onClick={this.getAllPatients}>{polyglot.t('staticFields.patientPicker.patientsTable.clearSearch')}</button>
        </div>
      </div>
      <div className='table-responsive'>
        <table className='table table-stripped table-bordered table-hover table-patients'>
          <thead>
            <tr>
              <th>{polyglot.t('staticFields.patientPicker.patientsTable.patientNumber')}</th>
              <th>{polyglot.t('staticFields.patientPicker.patientsTable.name')}</th>
              <th>{polyglot.t('staticFields.patientPicker.patientsTable.birthDate')}</th>
            </tr>
          </thead>
          <tbody>
            {this.state.currentDoctorPatients
            ? Object.keys(this.state.currentDoctorPatients).map(function (key) {
              return <tr key={key}>
                <td><Link to={`/patients/${this.state.currentDoctorPatients[key]['patientNumber']}`}>{this.state.currentDoctorPatients[key]['patientNumber']}</Link></td>
                <td><Link to={`/patients/${this.state.currentDoctorPatients[key]['patientNumber']}`}>{this.state.currentDoctorPatients[key].name}</Link></td>
                <td><Link to={`/patients/${this.state.currentDoctorPatients[key]['patientNumber']}`}>{moment(this.state.currentDoctorPatients[key]['birthDate']).format('LL')}</Link></td>
              </tr>
            }.bind(this))
            : !this.state.noPatients ? this.renderLoading() : this.renderNoPatients()
          }
          </tbody>
        </table>
      </div>
    </div>
  }
}

const PatientNumberForm = (props) => {
  return <div>
    <div className={props.alert} role='alert'>{polyglot.t('staticFields.patientPicker.patientNumberForm.noPatientWithThisNumber')}</div>
    <form name='user-info' id='login-form' onSubmit={props.handleSubmit}>
      <div className='form-group'>
        <label htmlFor='idNumber'>{polyglot.t('staticFields.patientPicker.patientNumberForm.patientNumber')}</label>
        <input type='text' name='patientId' className='form-control' placeholder={polyglot.t('staticFields.patientPicker.patientNumberForm.number')}
          value={props.patientId} onChange={(e) => props.handleChange(e)} />
      </div>
      <button type='submit' className='btn btn-personalized btn-large btn-block'>{polyglot.t('staticFields.commonFields.enter')}</button>
    </form>
  </div>
}

PatientNumberForm.propTypes = {
  alert: PropTypes.string.isRequired,
  patientId: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/PatientPicker/PatientPicker.js